// extracted by mini-css-extract-plugin
module.exports = {"page":"frequent_page__2aaIt","container":"frequent_container__2u_VM","title":"frequent_title__SOR3b","text":"frequent_text__2BoU4"};